import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './OfferDetailController.json';

const queryOfferDetailInfo = (req, res, ctx) => {
  const responseData = MOCK_DATA['OfferDetailController/queryOfferDetailInfo'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const userAppLight = (req, res, ctx) => {
  const responseData = MOCK_DATA['OfferDetailController/userAppLight'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('OfferDetailController/queryOfferDetailInfo'),
    withScenario(withAuthCheck(queryOfferDetailInfo))
  ),
  rest.post(getApiEndpoint('OfferDetailController/userAppLight'), withScenario(withAuthCheck(userAppLight))),
];
